import { FieldsTypes, GeneralFieldsName } from "../consts";
import { fDate } from "./minimal/formatTime.js";
import NimiTermsOfService from '../assets/docs/nimi-terms-of-services.pdf'
import NimiPrivacyPolicy from '../assets/docs/nimi-privacy-policy.pdf'
import MyKindPrivacyPolicy from '../assets/docs/mykind-privacy-policy.pdf'
import MyKindTermsOfService from '../assets/docs/mykind-terms-of-services.pdf'
import * as Yup from "yup";

export const extractId = (entity) => entity._id

export const eventInputDataToFields = (eventInputData = []) => {
    // Initialize with default field values to prevent undefined errors
    const fields = {
        custom_questions: [],
        birthdayField: { required: false, isHidden: true },
        lnameField: { required: false, isHidden: false },
        fnameField: { required: false, isHidden: false },
        emailField: { required: true, isHidden: false },
        phoneField: { required: true, isHidden: false },
        genderField: { required: false, isHidden: true },
        socialLinkField: { required: false, isHidden: true },
        businessCodeField: { required: false, isHidden: true },
        businessNameField: { required: false, isHidden: true },
        emailMarketingField: { required: false, isHidden: true }
    }
    for (const field of eventInputData) {
        switch (field.name) {
            case GeneralFieldsName.B_DAY:
                fields.birthdayField = field
                break
            case GeneralFieldsName.L_NAME:
                fields.lnameField = field
                break
            case GeneralFieldsName.F_NAME:
                fields.fnameField = field
                break
            case GeneralFieldsName.EMAIL:
                fields.emailField = field
                break
            case GeneralFieldsName.PHONE:
                fields.phoneField = field
                break
            case GeneralFieldsName.GENDER:
                fields.genderField = field
                break
            case GeneralFieldsName.SOCIAL_LINK:
                fields.socialLinkField = field
                // Extract custom validations if they exist
                if (field.customValidations) {
                    fields.socialLinkField = {
                        ...field,
                        customValidations: field.customValidations
                    }
                }
                break
            case GeneralFieldsName.BUSINESS_CODE:
                fields.businessCodeField = field
                break
            case GeneralFieldsName.BUSINESS_NAME:
                fields.businessNameField = field
                break
            case GeneralFieldsName.EMAIL_MARKETING:
                fields.emailMarketingField = field
                break
            default:
                if (field.name?.startsWith('custom_q_')) {
                    fields.custom_questions.push({
                        custom_name: field.name,
                        custom_placeholder: field.placeholder,
                        custom_required: field.required,
                        custom_type: field.type
                    })
                } else {
                    console.log("what is this field?");
                    console.log(field);
                }
        }
    }
    return fields
}

export const buildUserEventSchemaByEventInputData = (formFields, ignoreCustomQuestions = false) => {
    const ticketSchema = {}
    const { birthdayField, lnameField, fnameField, emailField, phoneField, genderField, socialLinkField, custom_questions, businessCodeField, businessNameField } = formFields;

    if (birthdayField?.required) {
        ticketSchema.birth_date = Yup.date().required() // .min .max('2019-08-01')
    } else if (!birthdayField?.isHidden) {
        ticketSchema.birth_date = Yup.date()
    }

    if (lnameField.required) {
        ticketSchema.lname = Yup.string().trim().required()
    } else if (!lnameField.isHidden) {
        ticketSchema.lname = Yup.string().trim()
    }

    if (fnameField.required) {
        ticketSchema.fname = Yup.string().trim().required()
    } else if (!fnameField.isHidden) {
        ticketSchema.fname = Yup.string().trim()
    }

    // if (emailField.required) {
    ticketSchema.email = Yup.string().trim().lowercase().required()
    // } else if (!emailField.isHidden) {
    //     ticketSchema.email = Yup.string().trim().lowercase()
    // }

    // if (phoneField.required) {
    ticketSchema.phone = Yup.string().trim().required()
    // } else if (!phoneField.isHidden) {
    //     ticketSchema.phone = Yup.string().trim()
    // }

    if (genderField.required) {
        ticketSchema.gender = Yup.string().required()
    } else if (!genderField.isHidden) {
        ticketSchema.gender = Yup.string()
    }

    // if (socialLinkField.required) {
    //     ticketSchema.social_link = Yup.string().trim().required()
    // } else if (!socialLinkField.isHidden) {
    //     ticketSchema.social_link = Yup.string().trim()
    // }

    // Handle social link with custom validations
    if (socialLinkField) {
        if (socialLinkField.required) {
            ticketSchema.social_link = Yup.string().trim().required()
        } else if (!socialLinkField.isHidden) {
            ticketSchema.social_link = Yup.string().trim()
        }

        // Add custom validation if customValidations exist
        if (ticketSchema.social_link && socialLinkField.customValidations?.must_contain_one_of_the_following?.length > 0) {
            const allowedNetworks = socialLinkField.customValidations.must_contain_one_of_the_following
            const errorMessage = socialLinkField.customValidations.error_message || 'Please provide a valid social network link'
            //TODO
            ticketSchema.social_link = ticketSchema.social_link.test(
                'social-network-validation',
                errorMessage,
                function (value) {
                    if (!value) return true // Let required validation handle empty values
                    const normalizedValue = value.toLowerCase().trim()
                    return allowedNetworks.some(network => normalizedValue.includes(network))
                }
            )
        }
    }

    if (businessCodeField) {
        if (businessCodeField.required) {
            ticketSchema.businessCode = Yup.string().trim().required()
        } else if (!businessCodeField.isHidden) {
            ticketSchema.businessCode = Yup.string().trim()
        }
    }
    if (businessNameField) {
        if (businessNameField.required) {
            ticketSchema.businessName = Yup.string().trim().required()
        } else if (!businessNameField.isHidden) {
            ticketSchema.businessName = Yup.string().trim()
        }
    }

    if (custom_questions.length && !ignoreCustomQuestions) {
        for (const customQ of custom_questions) {
            switch (customQ.custom_type) {
                case FieldsTypes.STRING:
                    ticketSchema[customQ.custom_name] = customQ.custom_required ? Yup.string().trim().required() : Yup.string().trim()
                    break
                case FieldsTypes.DATE_NO_TIME:
                    ticketSchema[customQ.custom_name] = customQ.custom_required ? Yup.date().required() : Yup.date()
                    break
                case FieldsTypes.YES_OR_NO:
                    ticketSchema[customQ.custom_name] = customQ.custom_required ? Yup.boolean().required() : Yup.boolean()
                    break
            }

        }
    }

    return ticketSchema
}

export const extractCustomQuestionsFromEventInputData = (eventInputData) => {
    const results = []
    for (const inputData of eventInputData) {
        if (inputData.name.startsWith('custom_q')) {
            results.push(inputData)
        }
    }
    return results
}

export const transformCustomQuestionValueByType = (customQuestion, value, translate) => {
    if (!value) {
        return "-"
    }
    switch (customQuestion.type) {
        case FieldsTypes.DATE_NO_TIME:
            return fDate(value)
        case FieldsTypes.YES_OR_NO:
            return value === "1" ? translate('transformers.yes') : translate('transformers.no')
        case FieldsTypes.STRING:
            return value
    }
}

// Prepare number for whatsApp format
export const normalizePhoneNumber = (number) => {
    if (number.startsWith('0') || number.startsWith('+')) {
        return number.slice(1, 1) + number.slice(1, number.length)
    }
}



export const getRelevantPaymentFormError = (e, translate) => {
    const { EXPIRATION, NUMBER, CVC, NAME_FIRST, NAME_LAST } = window.PayMe.fields

    let errorToRender
    // setting a default error message in case we don't have a specific one to show
    errorToRender = e?.payload?.status_error_details ||  e?.userFacingMessage || e?.message
    if (e?.message) {
        if (e.message === "Invalid phone number") {
            errorToRender = translate('event_page.payment_invalid_phone_number')
            return errorToRender
        }
        if (e.message.includes("`email` is required")) {
            errorToRender = translate('event_page.payment_invalid_email')
            return errorToRender
        }
        if (e.message.includes("seats already taken")) {
            /* this is the server error message when the seats are already taken  
            `seats already taken (${seatsTaken.toString()}) in order number: ${JSON.stringify(
                   eventOrderNumbers
               )} for event: ${event._id.toString()}`
            */
            const seatsTaken = e.message.split("(")[1].split(")")[0]
            errorToRender = translate('event_page.seats_already_taken') + ` ${seatsTaken}`
            // check if current url contains the /dashboard/ path if so we need to show a different message
            if (window.location.pathname.includes('/dashboard/')) {
                const eventOrderNumbers = e.message.split("order number: ")[1].split(" for event:")[0]
                errorToRender += ` ${translate('transformers.order_number_prefix')} ${eventOrderNumbers}`
            }
            return errorToRender
        }
    }
    // Mean we had an error with the 'PayMe'
    if (e?.type === 'tokenize-error') {
        // This is errors from PayMe api (after form submitted)
        if (e.payload) {
            if (e.payload.status_error_details === "Invalid credit card expiry") {
                errorToRender = translate('event_page.invalid_card_expiry')
                return errorToRender
            }
            if (e.payload.status_error_details === "Incorrect card number") {
                errorToRender = translate('event_page.invalid_card_number')
                return errorToRender
            }
            if (e.payload.status_error_details === "Invalid credit card CVV") {
                errorToRender = translate('event_page.invalid_card_cvv')
                return errorToRender
            }
            if (e.payload.status_error_details && e.payload.status_error_details.toLowerCase().includes("refusal by credit company")) {
                errorToRender = translate('event_page.refusal_payment')
                return errorToRender
            }
            if (e.payload.status_error_details) {
                errorToRender = e.payload.status_error_details
                return errorToRender
            }
        }
        // This is errors from PayMe sdk (before form submitted)
        if (e.errors) {
            if (e.errors[EXPIRATION]) {
                errorToRender = translate('event_page.missing_fields')
            }
            if (e.errors[NUMBER]) {
                errorToRender = translate('event_page.missing_fields')
            }
            if (e.errors[CVC]) {
                errorToRender = translate('event_page.missing_fields')
            }
            if (e.errors[NAME_FIRST]) {
                errorToRender = translate('event_page.missing_fields')
            }
            if (e.errors[NAME_LAST]) {
                errorToRender = translate('event_page.missing_fields')
            }
        }
    }
    return errorToRender
}

export const getRelevantHrcError = (e, translate) => {
    let message = e.message ? e.message.toLowerCase() : ""
    if (message) {
        if (message.includes("already used for this event")) {
            return translate('transformers.hrc_errors.subscription_already_used')
        }
        if (message.includes("season ticket not active or limit is reached")) {
            return translate('transformers.hrc_errors.subscription_not_active')
        }
        if (message.includes("end user season ticket limit reached for this event")) {
            return translate('transformers.hrc_errors.no_entries_left_for_event')
        }
        if (message.includes("end user season ticket limit reached")) {
            return translate('transformers.hrc_errors.no_entries_left')
        }
        if (message.includes("end user season ticket not configured for this event")) {
            return translate('transformers.hrc_errors.not_configured_for_event')
        }
        return translate(e.message)
    }
    return translate('transformers.hrc_errors.subscription_not_found')
}
